export const SUCCESS_THRESHOLD = 0.6

export const DEFAULT_PAD_LENGTH = 3
export const FULL_PAD_LENGTH = 4
